import React from "react";
import { RequestState } from "src/models/RequestState";
import { PublicationDetail } from "src/models/PublicationDetail";
import { Api } from "src/core/api";
import axios from "axios";
import { Dialog } from "./Dialog";
import { css } from "aphrodite-jss";
import { styles } from "./PublicationDetailDialogStyle";
import { JsonConvert } from "json2typescript";
import { PublicationListItem, PublicationAuthor } from "../../models/PublicationListItem";
import { Author } from "src/models/CoAuthor";

interface IPublicationDetailDialogProps {
    isOpen: boolean;
    onClose: any;
    data: PublicationListItem;
    isMinimal: boolean;
}

export class PublicationDetailDialog extends React.Component<IPublicationDetailDialogProps> {

    public static defaultProps = {
        isOpen: false,
        onClose: ()=>{},
        data: new PublicationListItem()
    };

    constructor(props: IPublicationDetailDialogProps) {
        super(props);
    }

    public render() {

        let visibility;
        if(this.props.isMinimal){
            visibility = {
                display: "none"
            }
        }else{
            visibility = {

            }
        }

        return (            
            <Dialog isOpen={this.props.isOpen} onClose={this.props.onClose} > 
                <div id="container" className={css(styles.container)}>
                    <React.Fragment>
                    <div id="content" className={css(styles.content)} >

                        <a id="title" href={this.props.data.scopus_self_link} target="_" className={css(styles.title)}  >
                            {this.props.data.title}
                        </a>

                        <div id="source" className={css(styles.source)}>
                            <div id="label">
                                Source:  
                            </div>
                            <div id="name" >
                                {this.props.data.source_name} 
                            </div>
                        </div>

                        <div id="doi" className={css(styles.doi)} style={visibility}>
                            <div id="label">
                                DOI:  
                            </div>
                            <div id="name" >
                                {this.props.data.doi} 
                            </div>
                        </div>

                        <div id="date" className={css(styles.date)}>
                            <div id="label" >
                                Publication Date: 
                            </div>
                            <div id="name" >
                                {this.props.data.pub_date} 
                            </div>
                        </div>

                        <div id="authors" className={css(styles.authors)}>
                            <div id="label" >
                                Authors:  
                            </div>
                            <div>
                                {this.props.data.authors.map((author: PublicationAuthor)=>{return author.first_name + " " + author.last_name}).join(", ")}
                            </div>
                        </div>

                        <div id="abstrat" className={css(styles.abstract)} style={visibility}  >
                            <div id="label" >
                                Abstract
                            </div>
                            <div>
                                {this.props.data.abstract}
                            </div>
                        </div>
            </div>
                    </React.Fragment>
                </div>
            </Dialog>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dialogs/PublicationDetailDialog.tsx